<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <!-- 弹窗, 新增 / 修改 -->
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData">
      <template v-slot:hierarchy="update">
        <HIERARCHY :update="update"></HIERARCHY>
      </template>
      <template v-slot:product="update">
        <PRODUCT :update="update"></PRODUCT>
      </template>
    </UPDATE>
    <UPDATE ref="exportUpdate" :updateData="exportUpdate" @uploadFile="uploadFile"></UPDATE>
  </div>
</template>

<script>
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import download from '@/utils/download'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import Qs from 'qs'
    import HIERARCHY from '@/views/newmis36/accountReward/hierarchy.vue'
    import PRODUCT from '@/views/newmis36/accountReward/product.vue'

    let activeStatus = {"-1": "活动状态", "DRAFT": "待执行", "PENDING": "执行中", "DISABLE": "禁用", "END": "已到期","WILL":"未开始"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE,
            HIERARCHY,
            PRODUCT
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            uploadFile(col,res){
                this.$refs.exportUpdate.close();
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    //修改
                    row.acitveDate = [row.beginDate,row.endDate];
                    row.hierarchy = JSON.parse(row.hierarchy);
                    row.product = JSON.parse(row.product);
                    this.updateData.submit = "show";
                    this.$refs.childUpdate.open(row);
                }else if(clickName == "approve"){
                    //审核提案
                    this.dataChanage(URL.rebateActivity.applyProposal, {id:row.id}, res => {
                        if (res.code == 0) {
                            this.$message.success("suc");
                        } else {
                            this.$message.error(res.message);
                        }
                        this.$refs.childTable.defaultQueryData(this.queryData);
                    })
                }else if(clickName == "enable"){
                    let activeStatus = "DISABLE";
                    if (row.activeStatus == "DISABLE") activeStatus = "PENDING";
                    this.dataChanage(URL.rebateActivity.editActiveStatus, {id:row.id,activeStatus:activeStatus}, res => {
                        if (res.code == 0) {
                            this.$message.success("suc");
                        } else {
                            this.$message.error(res.message);
                        }
                        this.$refs.childTable.defaultQueryData(this.queryData);
                    })
                }else if(clickName == "detail"){
                    row.acitveDate = [row.beginDate,row.endDate];
                    row.hierarchy = JSON.parse(row.hierarchy);
                    row.product = JSON.parse(row.product);
                    this.updateData.submit = "close";
                    this.$refs.childUpdate.open(row);
                }else if(clickName == "exportBlack"){
                    //导入黑名单
                    const option = {activeId:row.activeId};
                    this.exportUpdate.cols = [{ title: window.$t("common.import"), field: 'users',type:11,option:option,action:URL.tradingRebate.export,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},];
                    this.$refs.exportUpdate.open();
                }else if(clickName == "blackDetail"){
                    //跳转到黑名单页面 /newmis36/accountReward/black
                    this.$router.push({path:"/newmis36/accountReward/black",query:{activeId:row.activeId,label:"TREX"}})
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('txmis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('txmis.bt.add') == clickName) {
                    this.updateData.submit = "show";
                    this.$refs.childUpdate.open();
                } else if (window.$t('txmis.bt.down') == clickName) {
                    download.exportExcel(URL.rebateActivity.downloadActivity, data, window.$t('txmis.accountReward.downloadActivity0'));
                }
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
            submit(model){
                model.beginDate = model.acitveDate[0];
                model.endDate = model.acitveDate[1];
                model.hierarchy = JSON.stringify(model.hierarchy);
                model.product = JSON.stringify(model.product);
                this.dataChanage(URL.rebateActivity.edit, model, res => {
                    if (res.code == 0) {
                        this.$message.success("suc");
                        this.$refs.childUpdate.close();
                    } else {
                        this.$message.error(res.message);
                    }
                    this.$refs.childTable.defaultQueryData(this.queryData);
                })
            }
        },
        data() {
            return {
                addOrUpdateVisible: false,
                queryData: {},
                dataForm: {},
                exportUpdate:{
                    submit: 'hidden',
                    //{ title: window.$t("common.import"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},
                    cols:[],
                },
                updateData:{
                    width:"70%",
                    cols:[
                        { title: 'id', field: 'id',hidden:true},
                        //0:交易返利，1：推荐赠金
                        { title: 'activeType', field: 'activeType',data:1,hidden:true},
                        //是否是提案数据(0:普通活动数据，1：提案数据
                        { title: 'isproposal', field: 'isproposal',data:0,hidden:true},
                        {title: window.$t('txmis.accountReward.activeName'), field: 'activeName',required:true},
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId',required:true},
                        {title: window.$t('txmis.accountReward.acitveDate'), field: 'acitveDate',type:9,data:[],format:"yyyy-MM-dd HH:mm:ss",required:true},
                        {title: window.$t('txmis.rebateComponents.highAmount')+"(:美元)", field: 'highAmount',type:7,min:0,required:true},
                        {title: window.$t('txmis.accountReward.expDay')+"(:天)", field: 'expDay',type:7,min:0,required:true},
                        {title: window.$t('txmis.accountReward.hierarchy'), field:'hierarchy',type:10,slot:'hierarchy',data:[{}],required:true},
                        {title: window.$t('txmis.accountReward.tradeConfig'), field:'product',type:10,slot:'product',required:true,data:
                                [
                                    {"rebateType": 1,"levelName":"迷你","levelType":"MIN",value:[{productType:'-1',me:0,direct:0,indirect:0,quantity:0}]},
                                    {"rebateType": 1,"levelName":"标准","levelType":"STD",value:[{productType:'-1',me:0,direct:0,indirect:0,quantity:0}]},
                                    {"rebateType": 1,"levelName":"铂金","levelType":"PLA",value:[{productType:'-1',me:0,direct:0,indirect:0,quantity:0}]},
                                ]
                        },
                    ],
                },
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('txmis.common.startTime'), field: 'beginDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('txmis.common.endTime'), field: 'endDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('txmis.accountReward.activeStatus'), field: 'activeStatus', type: 2, optionList: activeStatus},
                        {title: window.$t('txmis.accountReward.activeName'), field: 'activeName'},
                        {title: window.$t('txmis.accountReward.activeType'), field: 'activeType', data: 1, hidden: true},
                        {click: window.$t('txmis.bt.query')},
                        {click: window.$t('txmis.bt.add')},
                        {click: window.$t('txmis.bt.down')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.rebateActivity.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.accountReward.proposalNo'), field: 'proposalNo',h5Click:"detail"},
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('txmis.accountReward.activeName'), field: 'activeName'},
                        {
                            title: window.$t('txmis.accountReward.activeStatus'), field: 'activeStatus', render: (data, full) => {
                                return activeStatus[data] || "";
                            }
                        },
                        {title: window.$t('txmis.accountReward.beginDate'), field: 'beginDate'},
                        {title: window.$t('txmis.accountReward.endDate'), field: 'endDate'},
                        {title: window.$t('txmis.accountReward.expDay'), field: 'expDay'},
                        {title: window.$t('txmis.accountReward.proposalUser'), field: 'proposalUser'},
                        {title: window.$t('txmis.accountReward.proposalDate'), field: 'proposalDate'},
                        {title: window.$t('txmis.accountReward.approvalUser'), field: 'approvalUser'},
                        {title: window.$t('txmis.accountReward.approvalDate'), field: 'approvalDate'},
                        {
                            title: window.$t('txmis.bt.operation'),
                            btnClick:[
                                {name:window.$t("txmis.bt.edit"),click:"update",type:"primary",icon:"el-icon-update",hidden:(data,full)=>{
                                        return full.activeStatus != 'DRAFT' && full.activeStatus != '-1';
                                    }},
                                {name:window.$t('txmis.accountReward.approve'),click:"approve",type:"primary",icon:"el-icon-update",hidden:(data,full)=>{
                                        return full.activeStatus != 'DRAFT' && full.activeStatus != '-1';
                                    }},
                                {name:"导入黑名单",click:"exportBlack",type:"primary",icon:"el-icon-update"},
                                {name:"黑名单",click:"blackDetail",type:"primary",icon:"el-icon-update"},
                                {name:(data,full)=>{
                                        return full.activeStatus == "DISABLE"?window.$t("txmis.bt.enable"):window.$t("txmis.bt.disable");
                                    },click:"enable",type:"primary",icon: "el-icon-edit",
                                    hidden:(data,full)=>{
                                        return full.activeStatus == '-1' || full.activeStatus == 'DRAFT';
                                    }
                                }
                            ],
                            width:400
                        },
                    ]
                }
            }
        }
    }
</script>
